import ManagePortfolio from './ManagePortfolio';

export default ManagePortfolio;
